import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Col, Row, Button, Input, DropdownItem } from 'reactstrap';

import MagstimHeaderBar from './MagstimHeaderBar';
import FormControlNumber from './FormControlNumber';

//import { styles } from "./magstim"
import { styles } from "./magstim"
import { CurrentTheme, CurrentLang, MagstimColor, isPDA, MagstimDropdown } from "common";

class EditTreatmentPlanSummaryPanel extends React.Component {

	constructor(props) {
		super(props);

		this._inputPlanName = React.createRef();
		this._inputNumberTreatments = React.createRef();
		this._saveButton = React.createRef();

		this.state = {
			saveDisabled: true,
			uiControlMargin: isPDA() ? '20px' : '50px',
			name:"",
			nameTouched:false
		};
	}

	// eslint-disable-next-line no-unused-vars
	onChangePlanName = (_event) => {
		// console.log('EditTreatmentPlanSummaryPanel.onChangePlanName');
		this.setState({ saveDisabled: (undefined === this._inputPlanName.current.value) || (null === this._inputPlanName.current.value) || (0 === this._inputPlanName.current.value.length), 
						name: _event.target.value,
						nameTouched:true });

		if ((undefined !== this.props.onChangePlanName) && (null !== this.props.onChangePlanName)) {
			this.props.onChangePlanName(this._inputPlanName.current.value);
		}
	}

	// eslint-disable-next-line no-unused-vars
	onChangeNumberTreatments = (_event) => {
		if ((undefined !== this.props.onChangeNumberTreatments) && (null !== this.props.onChangeNumberTreatments)) {
			this.props.onChangeNumberTreatments(this._inputNumberTreatments.current.valueAsNumber);
		}
	}

	onChangeTreatmentStage = (id) =>{
		if ((undefined !== this.props.onChangeTreatmentStage) && (null !== this.props.onChangeTreatmentStage)) {
			this.props.onChangeTreatmentStage(id);
		}
	}

	onClickSave = (event) => {
		if ((undefined !== this.props.onClickSave) && (null !== this.props.onClickSave)) {
			this.props.onClickSave(event);
		}
	}

	onClickBack = (event) => {
		if ((undefined !== this.props.onClickBack) && (null !== this.props.onClickBack)) {
			this.props.onClickBack(event);
		}
	}

	componentDidMount() {
		this.setState({ saveDisabled: !this.props.planName || 0 === this.props.planName.length });
	}

	onNameFocus = () =>{
		this.setState({ nameTouched:true})
	}

	nameInput = () =>{
		if(isPDA() === true && this.state.nameTouched === true && this.state.name !== undefined && this.state.name.length === 0){
			return <>
					<Input innerRef={this._inputPlanName} 
					   defaultValue={this.props.planName} 
					   onChange={this.onChangePlanName} 
					   onFocus={this.onNameFocus}  
					   type="text" 
					   placeholder={CurrentLang().treatment_edit_plan_name_placeholder} style={styles.magstimFormControl} 
					   size={CurrentTheme().ControlSize}
					   className="form-control is-invalid"/>

				<div className="invalid-feedback">{CurrentLang().validation_required}</div>
			</>
		}
		else{
			return <>
				<Input innerRef={this._inputPlanName} 
					   defaultValue={this.props.planName} 
					   onChange={this.onChangePlanName} 
					   onFocus={this.onNameFocus}  
					   type="text" 
					   placeholder={CurrentLang().treatment_edit_plan_name_placeholder} style={styles.magstimFormControl} 
					   size={CurrentTheme().ControlSize}/>
			</>
		}
	}

	render() {
		//console.log('EditTreatmentPlanSummaryPanel.render', this.data, this.props, this.state);

		if ((undefined !== this._inputNumberTreatments.current) && (null !== this._inputNumberTreatments.current)) {
			if (undefined === this.isNumberTreatmentsDefaultSet) {
				this._inputNumberTreatments.current.setValue(this.props.numberTreatments);
				this.isNumberTreatmentsDefaultSet = true;
			}
		}

		var backButton = '';
		var treatmentState = <></>

		if (isPDA() === false) {
			backButton = <Button color="secondary" className="mt-1" onClick={this.onClickBack} size={CurrentTheme().ControlSize} ><i className="fas fa-arrow-left"></i></Button>
		}
		else {
			treatmentState = <>
				<label>{CurrentLang().edit_patient_treatment_stage_label}</label>
				<MagstimDropdown id="treatmentStage" onSelect={this.onChangeTreatmentStage}>
					{
						this.props.allTreatmentStages.map(option => {
							return <DropdownItem id={option} key={option} value={option} active={option === this.props.treatmentStage}>{CurrentLang()[`treatment_stage_${option.toLowerCase()}`]}</DropdownItem>
					})}
				</MagstimDropdown>
			</>
		}

		return (


			<Wrapper className="col ui-fillh" uiControlMargin={this.state.uiControlMargin} labelFontSize={CurrentTheme().labelFontSize}>

				<Row className="ui-header">
					<Col>
						<MagstimHeaderBar main_title={CurrentLang().treatment_edit_plan_summary} main_icon="fas fa-file-prescription" ShowClose={false}></MagstimHeaderBar>
					</Col>
				</Row>

				<div className="d-flex flex-column ui-fillh">
					<div className="ui-control-body">

						<label>{CurrentLang().treatment_edit_plan_name_label}</label>
						{this.nameInput()}

					</div>

					<div className="flex-grow-1 ui-control-body">

						<label>{CurrentLang().treatment_edit_number_of_treatment_label}</label>
						<FormControlNumber ref={this._inputNumberTreatments}
							defaultValue={this.props.numberTreatments}
							min={1}
							max={100}
							displayStepButtons={true}
							onChange={this.onChangeNumberTreatments}
							style={styles.magstimFormControl}
							size={CurrentTheme().ControlSize} />

						{treatmentState}
					</div>

					<div className="ml-5 mr-5 align-self-center ui-control-foot">
						{backButton}
						<Button color="primary" className="mt-1" ref={this._saveButton} disabled={this.state.saveDisabled} onClick={this.onClickSave} size={CurrentTheme().ControlSize}><i className="fas fa-check"></i></Button>
					</div>
				</div>

			</Wrapper>
		);
	}
}

EditTreatmentPlanSummaryPanel.propTypes = {
	onClickSave: PropTypes.func,
	onClickBack: PropTypes.func,
	planName: PropTypes.string,
	onChangePlanName: PropTypes.func,
	numberTreatments: PropTypes.number,
	onChangeNumberTreatments: PropTypes.func,
	onChangeTreatmentStage: PropTypes.func,
	AllTreatmentStages:PropTypes.array,
	TreatmentStage:PropTypes.string
};

EditTreatmentPlanSummaryPanel.defaultProps = {
	onClickSave: undefined,
	onClickBack: undefined,
	planName: '',
	onChangePlanName: undefined,
	numberTreatments: 1,
	onChangeNumberTreatments: undefined,
	onChangeTreatmentStage:undefined,
	allTreatmentStages:[],
	treatmentStage:''
};

// Shaun: I had to set the padding-left / padding-right here, because in the compiled "npm start" version it was 15px, and in the compiled version it was zero, screwing the layout!
const Wrapper = styled.aside`

	label {
		display: block;
		padding-top: 6px;
		padding-bottom: 6px;
		color: ${MagstimColor.MagstimGroupBackground};
		line-height: 48px;
		text-align: center;
		vertical-align: middle;
	}
	input[type=text] {
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
	}

	.input-group {
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
		button:first-of-type {
			border: none;
			border-right: solid 2px ${MagstimColor.MagstimTextBackground};
			border-radius: 0;
		}
		button:nth-of-type(2) {
			border: none;
			border-radius: 0 .3rem .3rem 0;
		}
	}

	.ui-control-body {
		margin:${props => props.uiControlMargin};

		label {
			font-size:${props => props.labelFontSize};
		  }
	}

	.ui-control-foot {

		.btn {
			transform: translateY(-200%);
			min-width: 160px;
			margin:5px;
			box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
		}
	}

	// Right align
	.invalid-feedback{
		text-align: right;
	}

	// Remove the BG image - as it goes over the calender icon
	.form-control.is-invalid, .was-validated .form-control:invalid{
		background-image:url('');
	}

	// Need so the textarea in MagstimInputGroupMultilineText shows the correct highlight 
	.was-validated .form-control:invalid, .form-control.is-invalid {
		border-color: #f86c6b;
	}

`;

export default EditTreatmentPlanSummaryPanel